module.exports = __webpack_public_path__ + "static/media/conclusion-1.12baad5a.svg";